import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
/*-----pages-----*/
import { Home } from "./Home";
import { Home2 } from "./Home2";
import { PostUno } from "./posts/test";
import { Home4 } from "./Home4";
import { Home5 } from "./Home5";
import { Home6 } from "./Home6";
import { Homefrelencer } from "./Home-frelencer";
import { Creativecarousel } from "./Creative-carousel";
import { NotFound } from "./404";

class App extends Component {
  render() {
    return (
      <React.Fragment>
        <Router>
          <Switch>
            <Route exact path="/" component={Home6} />
            <Route exact path="/deatils-blog" component={Home2} />
            <Route path="/Home2" component={Home5} />
            <Route path="/post-uno" component={PostUno} />
            <Route path="/Home4" component={Home4} />
            <Route path="/Home5" component={Home5} />
            <Route path="/Home" component={Home} />
            <Route path="/Home-frelencer" component={Homefrelencer} />
            <Route path="/Creative-carousel" component={Creativecarousel} />
            <Route component={NotFound} />
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}

export default App;
